/// <amd-module name="Repos/Views/Settings/Repositories-Policies/Components/PolicyInputCheckbox" />
import React = require("react");
import { SelectableItem } from "Repos/Views/Settings/Repositories-Policies/Contracts/Contracts";
import { css, getSafeId } from "VSSUI/Util";
import { Checkbox } from "VSSUI/Checkbox";
import { IObservableValue } from "VSS/Core/Observable";

interface IPolicyInputCheckboxProps {
    item: SelectableItem;
    isChecked: boolean | IObservableValue<boolean>;
    isDisabled: boolean;
    onChange: (value: boolean) => void;
}

export const PolicyInputCheckbox: React.FunctionComponent<IPolicyInputCheckboxProps> = ({
    item,
    isDisabled,
    isChecked,
    onChange
}) => (
        <Checkbox
            id={item.id}
            ariaLabelledBy={item.id + "cblabel"}
            key={item.id}
            className={css("policy-input-checkbox", "margin-0", "padding-top-16", item.className)}
            checked={isChecked}
            onChange={(event, value) => onChange(value)}
            disabled={isDisabled}
        >
            <div className="bolt-checkbox-label" id={getSafeId(item.id + "cblabel")}>
                <div>{item.value}</div>
                {item.description && (
                    <div>
                        <span className="body-s secondary-text">{item.description}</span>
                    </div>
                )}
            </div>
        </Checkbox>
    );